import type { SVGProps } from 'react'

// Solid bookmark used for supplier segmentation / service tags.
export default function Bookmark(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
      fill="none"
    >
      <path
        d="M6 4a2 2 0 0 0-2 2v14a1 1 0 0 0 1.55.83L12 16.2l6.45 4.63A1 1 0 0 0 20 20V6a2 2 0 0 0-2-2H6z"
        fill={props.fill || 'currentColor'}
      />
    </svg>
  )
}
